import actions from "./actions";

const initState = {
  tables: [],
  loading: true,
  billDetailsLoading: true,
  bill: [],
};

export default function tablesInfoReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_TABLES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.GET_TABLES_SUCCESS:
      return {
        ...state,
        tables: action.tables,
        loading: false,
      };

    case actions.TOGGAL_BILL_DETAILS_REQUEST:
      return {
        ...state,
        billDetailsLoading: true,
      };

    case actions.TOGGAL_BILL_DETAILS_SUCCESS:
      return {
        ...state,
        bill: action.bill,
        billDetailsLoading: false,
      };

    default:
      return state;
  }
}
